"use client";

import { toast } from "sonner";

interface ToastOptions {
  message: string;
  description?: string | React.ReactNode;
  type?: "success" | "error" | "info" | "warning";
  url?: string;
  dismissible?: boolean;
  closeButton?: boolean;
  duration?: number;
}

export const showToast = ({
  message,
  description,
  type = "info",
  url,
  dismissible = true,
  closeButton = true,
  duration = 5000,
}: ToastOptions) => {
  const toastContent = url ? (
    <div>
      <p>{description || message}</p>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-500 hover:text-blue-700 underline mt-2 block"
      >
        Download
      </a>
    </div>
  ) : (
    description || message
  );

  const toastOptions = {
    description: toastContent,
    dismissible,
    closeButton,
    duration,
  };

  switch (type) {
    case "success":
      toast.success(message, toastOptions);
      break;
    case "error":
      toast.error(message, toastOptions);
      break;
    case "warning":
      toast.warning(message, toastOptions);
      break;
    default:
      toast.info(message, toastOptions);
  }
};